<template>
  <div class="min-h-screen bg-white text-slate-950">
    <!-- Topbar -->
    <div class="hidden sm:block bg-[#062b62] text-white">
      <div
        class="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-2 text-xs sm:px-6 lg:px-8"
      >
        <div class="flex flex-wrap gap-x-5 gap-y-2">
          <span>◉ Atendimento especializado</span>
          <span>▣ Entrega digital</span>
          <span>▤ Nota fiscal</span>
          <span>◌ Suporte humano</span>
        </div>

        <a
          href="https://wa.me/5511910512647?text=Ol%C3%A1%2C%20preciso%20de%20atendimento."
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold hover:underline"
        >
          Precisa de ajuda? WhatsApp
        </a>
      </div>
    </div>

    <!-- Header -->
    <header
      class="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur"
    >
      <div
        class="mx-auto flex min-h-[64px] sm:min-h-[100px] max-w-7xl flex-wrap items-center justify-between gap-3 sm:flex-nowrap sm:gap-6 px-4 py-3 sm:px-6 lg:px-8"
      >
        <!-- Logo -->
        <NuxtLink
          to="/"
          aria-label="Casa do Software"
          class="flex shrink-0 items-center"
        >
          <img
            src="/logo-casa-do-software-cortada.png?v=2"
            alt="Casa do Software"
            class="block h-auto max-h-[44px] max-w-[150px] sm:max-h-[72px] sm:max-w-[280px] w-auto"
          />
        </NuxtLink>

        <!-- Menu -->
        <nav
          class="hidden items-center gap-6 text-sm font-semibold text-slate-700 lg:flex"
        >
          <NuxtLink to="/categoria/windows" class="hover:text-blue-700">
            Windows
          </NuxtLink>

          <NuxtLink to="/categoria/office" class="hover:text-blue-700">
            Office
          </NuxtLink>

          <NuxtLink to="/categoria/windows-server" class="hover:text-blue-700">
            Windows Server
          </NuxtLink>

          <NuxtLink to="/categoria/adobe" class="hover:text-blue-700">
            Adobe
          </NuxtLink>

          <NuxtLink to="/atendimento-e-politicas" class="hover:text-blue-700">
            Suporte
          </NuxtLink>

          <NuxtLink to="/blog" class="hover:text-blue-700"> Blog </NuxtLink>
        </nav>

        <!-- Atalhos com identificação -->
        <div class="flex shrink-0 items-center gap-1 sm:gap-3">
          <NuxtLink
            to="/buscar"
            aria-label="Buscar produtos"
            class="flex min-h-[44px] min-w-[44px] sm:min-h-[52px] sm:min-w-[60px] flex-col items-center justify-center gap-1 rounded-lg px-2 py-2 text-slate-700 transition hover:bg-blue-50 hover:text-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true">
              <circle cx="10.5" cy="10.5" r="6.5" />
              <path d="m16 16 4.5 4.5" />
            </svg>
            <span class="whitespace-nowrap text-[11px] font-semibold sm:text-xs">Buscar</span>
          </NuxtLink>

          <NuxtLink
            to="/minha-conta"
            aria-label="Minha conta"
            class="flex min-h-[44px] min-w-[44px] sm:min-h-[52px] sm:min-w-[60px] flex-col items-center justify-center gap-1 rounded-lg px-2 py-2 text-slate-700 transition hover:bg-blue-50 hover:text-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="8" r="3.5" />
              <path d="M5 21v-2a7 7 0 0 1 14 0v2" />
            </svg>
            <span class="whitespace-nowrap text-[11px] font-semibold sm:text-xs">Minha conta</span>
          </NuxtLink>

          <NuxtLink
            to="/carrinho"
            aria-label="Carrinho"
            class="flex min-h-[44px] min-w-[44px] sm:min-h-[52px] sm:min-w-[60px] flex-col items-center justify-center gap-1 rounded-lg px-2 py-2 text-slate-700 transition hover:bg-blue-50 hover:text-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true">
              <path d="M2 3h3l3 12h11l3-9H6" />
              <circle cx="9" cy="20" r="1" />
              <circle cx="18" cy="20" r="1" />
            </svg>
            <span class="whitespace-nowrap text-[11px] font-semibold sm:text-xs">Carrinho</span>
          </NuxtLink>
        </div>
      </div>
    </header>

    <!-- Atalhos rápidos de categorias no celular -->
    <nav
      aria-label="Categorias de produtos"
      class="flex gap-2 overflow-x-auto border-b border-slate-200 bg-white px-4 py-3 lg:hidden"
    >
      <NuxtLink
        to="/categoria/windows"
        class="shrink-0 rounded-full bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-800"
      >Windows</NuxtLink>
      <NuxtLink
        to="/categoria/office"
        class="shrink-0 rounded-full bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-800"
      >Office</NuxtLink>
      <NuxtLink
        to="/categoria/windows-server"
        class="shrink-0 rounded-full bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-800"
      >Windows Server</NuxtLink>
      <NuxtLink
        to="/categoria/adobe"
        class="shrink-0 rounded-full bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-800"
      >Adobe</NuxtLink>
    </nav>

    <main>
      <!-- Hero -->
      <section
        class="relative overflow-hidden bg-[radial-gradient(circle_at_top_right,_#dbeafe,_transparent_38%),linear-gradient(180deg,#ffffff_0%,#f8fbff_100%)]"
      >
        <div
          class="mx-auto grid max-w-7xl items-center gap-6 px-4 py-7 sm:gap-12 sm:px-6 sm:py-16 lg:grid-cols-2 lg:px-8 lg:py-24"
        >
          <div>
            <p
              class="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-blue-700"
            >
              Software para pessoas e empresas
            </p>

            <h1
              class="max-w-3xl text-3xl font-black leading-tight tracking-tight text-[#071a3d] sm:text-5xl lg:text-6xl"
            >
              Compre Licenças Windows e Office Originais
                <span class="block text-blue-700"> com Nota Fiscal </span>
            </h1>

            <p class="mt-6 max-w-2xl text-lg leading-8 text-slate-600">
              Encontre sistemas operacionais, produtividade e soluções
              profissionais com entrega digital, documentação fiscal e
              atendimento pós-venda.
            </p>

            <div class="mt-7 hidden gap-3 text-sm text-slate-700 sm:grid sm:grid-cols-2">
              <div class="flex items-center gap-2">
                <span class="text-blue-700">✓</span>
                Informações claras sobre cada licença
              </div>

              <div class="flex items-center gap-2">
                <span class="text-blue-700">✓</span>
                Entrega digital após a confirmação
              </div>

              <div class="flex items-center gap-2">
                <span class="text-blue-700">✓</span>
                Nota fiscal nas compras elegíveis
              </div>

              <div class="flex items-center gap-2">
                <span class="text-blue-700">✓</span>
                Atendimento pós-venda
              </div>
            </div>

            <div class="mt-9 flex flex-wrap gap-3">
              <NuxtLink
                to="/categorias"
                class="rounded-xl bg-[#062b62] px-6 py-3.5 text-sm font-bold text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-[#0a397e]"
              >
                Conhecer soluções
              </NuxtLink>

              <a
                href="https://wa.me/5511910512647?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20para%20escolher%20um%20software."
                target="_blank"
                rel="noopener noreferrer"
                class="rounded-xl border border-blue-700 bg-white px-6 py-3.5 text-sm font-bold text-blue-800 transition hover:bg-blue-50"
              >
                Falar com especialista
              </a>
            </div>

            <p class="mt-6 text-xs leading-5 text-slate-500">
              Empresa independente. Não somos afiliados nem representantes
              oficiais das marcas mencionadas.
            </p>
          </div>

          <div class="relative hidden lg:block">
            <div
              class="absolute inset-8 rounded-full bg-blue-200/50 blur-3xl"
            ></div>

            <div
              class="relative rounded-[2rem] border border-white/70 bg-white/70 p-7 shadow-2xl shadow-blue-900/10 backdrop-blur"
            >
              <div class="mx-auto grid max-w-xl gap-5 sm:grid-cols-2">
                <div
                  class="rounded-2xl border border-blue-100 bg-gradient-to-b from-blue-50 to-white p-5 shadow-sm"
                >
                  <div class="mb-10 text-xs font-bold text-blue-700">
                    WINDOWS
                  </div>

                  <div class="text-5xl font-black text-blue-700">11</div>

                  <div class="mt-3 font-bold">Windows Pro</div>

                  <div class="mt-1 text-xs text-slate-500">
                    Sistemas operacionais
                  </div>
                </div>

                <div
                  class="rounded-2xl border border-orange-100 bg-gradient-to-b from-orange-50 to-white p-5 shadow-sm"
                >
                  <div class="mb-10 text-xs font-bold text-orange-700">
                    OFFICE
                  </div>

                  <div class="text-5xl font-black text-orange-600">365</div>

                  <div class="mt-3 font-bold">Produtividade</div>

                  <div class="mt-1 text-xs text-slate-500">
                    Planos e versões
                  </div>
                </div>
              </div>

              <div
                class="mx-auto mt-6 h-5 w-[82%] rounded-[50%] bg-slate-300/60 blur-[1px]"
              ></div>
            </div>
          </div>
        </div>
      </section>

      <!-- Confiança -->
      <section class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div
          class="-mt-2 grid overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm md:grid-cols-4"
        >
          <div
            v-for="item in trustItems"
            :key="item.title"
            class="border-b border-slate-200 p-7 text-center last:border-0 md:border-b-0 md:border-r"
          >
            <div
              class="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-full bg-blue-50 text-xl text-blue-700"
            >
              {{ item.icon }}
            </div>

            <h2 class="font-bold text-[#071a3d]">
              {{ item.title }}
            </h2>

            <p class="mt-2 text-sm leading-6 text-slate-500">
              {{ item.text }}
            </p>
          </div>
        </div>
      </section>

      <!-- Produtos mais vendidos -->
      <HomeBestSellers />

      <!-- Ofertas da semana -->
      <HomeWeeklyOffers />

      <!-- Como funciona -->
      <section class="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div class="text-center">
          <h2 class="text-3xl font-black tracking-tight text-[#071a3d]">
            Como funciona
          </h2>

          <p class="mt-2 text-slate-500">
            Um processo simples, seguro e transparente
          </p>
        </div>

        <div class="mt-12 grid gap-8 md:grid-cols-5">
          <div
            v-for="(step, index) in steps"
            :key="step.title"
            class="relative text-center"
          >
            <div
              class="mx-auto grid h-16 w-16 place-items-center rounded-full bg-blue-50 text-2xl text-blue-700"
            >
              {{ step.icon }}
            </div>

            <div
              class="mx-auto mt-4 grid h-6 w-6 place-items-center rounded-full bg-blue-700 text-xs font-black text-white"
            >
              {{ index + 1 }}
            </div>

            <h3 class="mt-4 font-bold text-[#071a3d]">
              {{ step.title }}
            </h3>

            <p class="mt-2 text-sm leading-6 text-slate-500">
              {{ step.text }}
            </p>
          </div>
        </div>
      </section>

      <!-- Categorias -->
      <section class="bg-slate-50 py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div class="text-center">
            <h2 class="text-3xl font-black tracking-tight text-[#071a3d]">
              Soluções em destaque
            </h2>

            <p class="mt-2 text-slate-500">
              Explore nossas principais categorias
            </p>
          </div>

          <div
            class="mx-auto mt-10 grid max-w-5xl gap-5 sm:grid-cols-2 lg:grid-cols-3"
          >
            <NuxtLink
              v-for="category in categories"
              :key="category.title"
              :to="category.to"
              class="group rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm transition hover:-translate-y-1 hover:border-blue-200 hover:shadow-lg"
            >
              <div
                class="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-blue-50 text-3xl"
              >
                {{ category.icon }}
              </div>

              <h3 class="mt-5 font-black text-[#071a3d]">
                {{ category.title }}
              </h3>

              <p class="mt-2 min-h-16 text-sm leading-6 text-slate-500">
                {{ category.text }}
              </p>

              <span
                class="mt-5 inline-flex rounded-lg border border-slate-200 px-4 py-2 text-sm font-bold text-blue-800 group-hover:border-blue-200 group-hover:bg-blue-50"
              >
                {{ category.cta }}
              </span>
            </NuxtLink>
          </div>

          <div class="mt-8 text-center">
            <NuxtLink
              to="/categorias"
              class="inline-flex rounded-xl border border-blue-700 px-6 py-3 text-sm font-bold text-blue-800 hover:bg-blue-50"
            >
              Ver todas as categorias
            </NuxtLink>
          </div>
        </div>
      </section>

      <!-- Por que comprar -->
      <section
        class="mx-auto grid max-w-7xl gap-10 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:px-8"
      >
        <div>
          <h2 class="text-3xl font-black tracking-tight text-[#071a3d]">
            Por que comprar na Casa do Software?
          </h2>

          <ul class="mt-7 space-y-4 text-slate-700">
            <li v-for="benefit in benefits" :key="benefit" class="flex gap-3">
              <span class="font-black text-blue-700">✓</span>
              <span>{{ benefit }}</span>
            </li>
          </ul>
        </div>

        <div
          class="rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-50 to-white p-8"
        >
          <div
            class="grid h-16 w-16 place-items-center rounded-2xl bg-white text-3xl text-blue-700 shadow-sm"
          >
            ✓
          </div>

          <h3 class="mt-6 text-xl font-black text-blue-800">
            Transparência em primeiro lugar
          </h3>

          <p class="mt-4 leading-7 text-slate-600">
            Somos uma empresa independente e não temos vínculo oficial com as
            marcas mencionadas. Todas as marcas pertencem aos seus respectivos
            proprietários.
          </p>

          <NuxtLink
            to="/aviso-legal"
            class="mt-6 inline-flex font-bold text-blue-800 hover:underline"
          >
            Saiba mais sobre nós →
          </NuxtLink>
        </div>
      </section>

      <!-- Soluções para empresas -->
      <HomeBusinessSolutions />

      <!-- Avaliações do Google -->
      <HomeGoogleReviews />

      <!-- Tecnologias do catálogo -->
      <HomeCatalogTechnologies />

      <!-- Políticas -->
      <section class="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
        <div
          class="grid overflow-hidden rounded-2xl border border-slate-200 bg-white md:grid-cols-4"
        >
          <NuxtLink
            v-for="item in policyItems"
            :key="item.title"
            :to="item.to"
            class="border-b border-slate-200 p-6 last:border-0 hover:bg-slate-50 md:border-b-0 md:border-r"
          >
            <div class="text-2xl">
              {{ item.icon }}
            </div>

            <h3 class="mt-4 font-black text-[#071a3d]">
              {{ item.title }}
            </h3>

            <p class="mt-2 text-sm leading-6 text-slate-500">
              {{ item.text }}
            </p>

            <span class="mt-4 inline-flex text-sm font-bold text-blue-800">
              Saiba mais →
            </span>
          </NuxtLink>
        </div>
      </section>

      <!-- Atendimento final -->
      <HomeFinalCta />

      <!-- Segurança -->
      <section class="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
        <div
          class="flex flex-col items-start justify-between gap-6 rounded-2xl bg-gradient-to-r from-[#062b62] to-[#0b4a9c] px-7 py-7 text-white md:flex-row md:items-center"
        >
          <div>
            <h2 class="font-black">Ambiente seguro</h2>

            <p class="mt-1 text-sm text-blue-100">
              Seus dados e informações são protegidos durante a navegação e o
              pagamento.
            </p>
          </div>

          <div
            class="flex flex-wrap items-center gap-5 text-sm font-bold text-blue-50"
          >
            <span>SSL</span>
            <span>PIX</span>
            <span>Cartão</span>
            <span>Pagamento protegido</span>
          </div>
        </div>
      </section>
    </main>

    <!-- Rodapé -->
    <footer class="bg-[#062b62] text-blue-50">
      <div
        class="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-5 lg:px-8"
      >
        <div>
          <h2 class="font-black text-white">Casa do Software</h2>

          <p class="mt-4 text-sm leading-6 text-blue-100">
            Soluções de software com atendimento especializado e informações
            claras.
          </p>

          <div class="mt-5 text-xs leading-6 text-blue-200">
            <p>Softwares Mundi LTDA</p>
            <p>CNPJ: 66.464.267/0001-48</p>
            <p>AV ENG LUIZ CARLOS BERRINI, 1748</p>
            <p>Cidade Monções, São Paulo - SP</p>
          </div>
        </div>

        <div v-for="column in footerColumns" :key="column.title">
          <h3 class="font-black text-white">
            {{ column.title }}
          </h3>

          <ul class="mt-4 space-y-3 text-sm text-blue-100">
            <li v-for="link in column.links" :key="link.label">
              <a
                v-if="link.to.startsWith('http')"
                :href="link.to"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-white hover:underline"
              >
                {{ link.label }}
              </a>

              <NuxtLink
                v-else
                :to="link.to"
                class="hover:text-white hover:underline"
              >
                {{ link.label }}
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div>
          <h3 class="font-black text-white">Atendimento</h3>

          <ul class="mt-4 space-y-3 text-sm text-blue-100">
            <li>
              <a
                href="https://wa.me/5511910512647?text=Ol%C3%A1%2C%20preciso%20de%20atendimento."
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-white hover:underline"
              >
                WhatsApp: (11) 91051-2647
              </a>
            </li>

            <li>Segunda a sexta: 9h às 18h</li>

            <li>
              <a
                href="mailto:comercial@casadosoftware.com.br"
                class="hover:text-white hover:underline"
              >
                comercial@casadosoftware.com.br
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="border-t border-white/10 py-5 text-center text-xs text-blue-200"
      >
        © {{ new Date().getFullYear() }} Casa do Software. Todos os direitos
        reservados.
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
useSeoMeta({
  title: "Licenças Windows e Office Originais | Casa do Software",
  description:
    "Compre Windows, Office, Microsoft 365 e Windows Server com entrega digital, nota fiscal e informações claras sobre licenciamento.",
  ogTitle: "Licenças Windows e Office Originais | Casa do Software",
  ogDescription:
    "Compre Windows, Office, Microsoft 365 e Windows Server com entrega digital, nota fiscal e informações claras sobre licenciamento.",
  ogType: "website",
});

const trustItems = [
  {
    icon: "◎",
    title: "Atendimento em todo o Brasil",
    text: "Atendemos pessoas e empresas em diferentes regiões do país.",
  },
  {
    icon: "✓",
    title: "Compra segura",
    text: "Navegação protegida e meios de pagamento reconhecidos.",
  },
  {
    icon: "◉",
    title: "Atendimento pós-venda",
    text: "Orientação comercial sobre o pedido, compatibilidade e condições do produto adquirido.",
  },
  {
    icon: "▤",
    title: "Documentação fiscal",
    text: "Informações fiscais conforme as condições de cada compra.",
  },
];

const steps = [
  {
    icon: "▦",
    title: "Escolha sua solução",
    text: "Selecione a categoria e confira detalhes, modalidade e compatibilidade.",
  },
  {
    icon: "▣",
    title: "Pagamento seguro",
    text: "Finalize utilizando as formas de pagamento disponíveis no checkout.",
  },
  {
    icon: "✈",
    title: "Entrega digital",
    text: "Receba por e-mail as informações e instruções após a confirmação.",
  },
  {
    icon: "⇩",
    title: "Instale e ative",
    text: "Siga o tutorial correspondente ao produto adquirido.",
  },
  {
    icon: "◉",
    title: "Conte com o suporte",
    text: "Nossa equipe auxilia quando houver necessidade de atendimento.",
  },
];

const categories = [
  {
    icon: "▦",
    title: "Windows",
    text: "Sistemas operacionais para uso pessoal e profissional.",
    cta: "Ver opções",
    to: "/categoria/windows",
  },
  {
    icon: "◆",
    title: "Office",
    text: "Soluções de produtividade para estudo, trabalho e empresas.",
    cta: "Ver opções",
    to: "/categoria/office",
  },
  {
    icon: "▤",
    title: "Windows Server",
    text: "Soluções para servidores e ambientes corporativos.",
    cta: "Ver opções",
    to: "/categoria/windows-server",
  },
];

const benefits = [
  "Informações claras sobre modalidade, duração e compatibilidade",
  "Entrega digital rápida e segura após a confirmação",
  "Nota fiscal conforme a operação realizada",
  "Atendimento pós-venda por WhatsApp, e-mail e telefone",
  "Políticas públicas de entrega, suporte e reembolso",
  "Empresa brasileira com CNPJ e canais de atendimento",
];

const policyItems = [
  {
    icon: "▣",
    title: "Formas de entrega",
    text: "Entenda como ocorre a entrega digital.",
    to: "/entrega-digital",
  },
  {
    icon: "↻",
    title: "Atendimento e políticas",
    text: "Consulte regras, prazos e procedimentos.",
    to: "/atendimento-e-politicas",
  },
  {
    icon: "⚖",
    title: "Licenciamento e origem",
    text: "Conheça nossas informações legais e comerciais.",
    to: "/aviso-legal",
  },
  {
    icon: "◉",
    title: "Suporte e atendimento",
    text: "Veja os canais e horários de atendimento.",
    to: "/atendimento-e-politicas",
  },
];

const footerColumns = [
  {
    title: "Categorias",
    links: [
      {
        label: "Windows",
        to: "/categoria/windows",
      },
      {
        label: "Office",
        to: "/categoria/office",
      },
      {
        label: "Windows Server",
        to: "/categoria/windows-server",
      },
    ],
  },
  {
    title: "Institucional",
    links: [
      {
        label: "Quem somos",
        to: "/about-us",
      },
      {
        label: "Licenciamento e origem",
        to: "/aviso-legal",
      },
      {
        label: "Política de entrega",
        to: "/entrega-digital",
      },
      {
        label: "Atendimento e políticas",
        to: "/atendimento-e-politicas",
      },
      {
        label: "Avaliações",
        to: "/avaliacoes",
      },
    ],
  },
  {
    title: "Suporte",
    links: [
      {
        label: "Central de ajuda",
        to: "/atendimento-e-politicas",
      },
      {
        label: "Como comprar",
        to: "/atendimento-e-politicas",
      },
      {
        label: "Formas de pagamento",
        to: "/atendimento-e-politicas",
      },
      {
        label: "Falar com o suporte",
        to: "https://wa.me/5511910512647?text=Ol%C3%A1%2C%20preciso%20de%20suporte.",
      },
    ],
  },
];
</script>
